<template>
    <div class="overlayDescContainer" v-if="showIntroduction">
        <div class="containerDesc">
            <div class="descclose_btn" @click="closeModal">
              <img src="../assets/defult/img/closebtn.png" alt="" srcset="">
            </div>
            <div v-html="this.introduction " class="introduction_desc">

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name : 'lottery_desc',
  props : {
    introduction : {
      type : String,
      required : true,
      default : ""
    },
    showIntroduction : {
      type : Boolean,
      required : true,
      default : false
    }
  },
  methods : {
    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/lottery_desc.vue